import { Modal, Button } from "react-bootstrap";

const AlertModal = ({ show, onClose, message, variant = "danger" }) => {
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton className={`bg-${variant} text-white`}>
        <Modal.Title>
          {variant === "success" && "✅ Gelukt"}
          {variant === "danger" && "❌ Fout"}
          {variant === "warning" && "⚠️ Waarschuwing"}
          {variant === "info" && "ℹ️ Informatie"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant={variant} onClick={onClose}>
          Sluiten
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AlertModal;